import { render, staticRenderFns } from "./LogoutConfirmation.vue?vue&type=template&id=1bab2d39"
import script from "./LogoutConfirmation.vue?vue&type=script&lang=js"
export * from "./LogoutConfirmation.vue?vue&type=script&lang=js"
import style0 from "./LogoutConfirmation.vue?vue&type=style&index=0&id=1bab2d39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports